import React, { FC, useState, useRef, useLayoutEffect } from 'react';
import { Button } from 'antd';
import cx from 'classnames';
import styles from './styles.module.css';

type Props = {
  selectedText?: string | null;
  className?: string;
  isCreateTask?: boolean;
};

const OriginalTextFromSelection: FC<Props> = ({
  selectedText,
  className,
  isCreateTask
}) => {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);
  const expandedRef = useRef(expanded);
  expandedRef.current = expanded;

  useLayoutEffect(() => {
    if (expandedRef.current) {
      setIsTruncated(false);
      return;
    }
    const el = textRef.current;
    if (!el) return;
    setIsTruncated(el.scrollWidth > el.clientWidth);
  }, [selectedText, expanded]);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) return;
    const observer = new ResizeObserver(() => {
      if (expandedRef.current) {
        setIsTruncated(false);
        return;
      }
      if (!textRef.current) return;
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [selectedText, expanded]);

  const showButton = expanded || isTruncated;

  if (!selectedText) return null;

  return (
    <div className={cx(styles.fromSelection, className)}>
      <span className={styles.originalText}>Replace:</span>
      <div className={styles.selectedTextRow}>
        <div
          className={cx(styles.selectedText, {
            [styles.selectedTextCollapsed]: !expanded,
            [styles.isCreateTask]: isCreateTask
          })}
        >
          <span
            ref={textRef}
            className={styles.selectedTextInner}
            title={expanded ? undefined : selectedText}
            data-cy="original-copy-text"
          >
            {'"' + selectedText + '"'}
          </span>
          {showButton && (
            <span
              size="small"
              className={styles.viewAllButton}
              onClick={() => setExpanded(prev => !prev)}
            >
              {expanded ? ' ...see less' : ' see more'}
            </span>
          )}
        </div>
      </div>
      <span className={styles.originalText}>With:</span>
    </div>
  );
};

export default OriginalTextFromSelection;
